import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { mapShippingMethods } from '../../../../mappers/view/shipping-methods.js';
import '../../../../mappers/errors-mapping.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import { ShippingMethodsList } from '../components/ShippingMethodsList.js';
import { ShippingMethodInfo } from '../components/ShippingMethodInfo.js';

const ShippingMethodsListContainer = ({ shippingMethodList , asides , onChange , selectedShippingMethod , handleOnShippingMethodSelected , isLoading , error  })=>{
    const { getLabel , locale  } = useIntl();
    const { shippingMethodsLogos  } = useCheckoutSettings();
    const labels = React.useMemo(()=>({
            errorTitle: getLabel('checkout.errors.general.title'),
            errorMessage: getLabel('checkout.errors.general.message'),
            free: getLabel('common.free'),
            required: getLabel('common.form.field.requiredError')
        })
    , [
        getLabel
    ]);
    const shippingMethodInfo = ({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(ShippingMethodInfo, {
            price: price,
            logo: logo,
            isFree: isFree
        })
    ;
    const items = mapShippingMethods({
        asides,
        logos: shippingMethodsLogos,
        locale,
        shippingMethodList,
        shippingMethodInfo
    });
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "error",
            title: labels.errorTitle,
            className: "alert-m-default"
        }, labels.errorMessage);
    }
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: (method)=>{
            onChange === null || onChange === void 0 ? void 0 : onChange();
            handleOnShippingMethodSelected === null || handleOnShippingMethodSelected === void 0 ? void 0 : handleOnShippingMethodSelected(method);
        },
        shippingMethodItems: items,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), hasValidationError && /*#__PURE__*/ React.createElement(Text, {
        className: "form-control__error"
    }, labels.required));
};

export { ShippingMethodsListContainer };
//# sourceMappingURL=ShippingMethodsListContainer.js.map
